import { IMachineNotifications, IMachineNotificationsStarted, INotifications } from '@app/@introspection';
import { ComputerIcon } from '@app/shared/icons';
import { Inject } from '@rxdi/core';
import { Component, html, LitElement, property } from '@rxdi/lit-html';

import { DateTimeProvider } from '../../date-time/date-time.service';

export const isMachineStartedNotification = (n: INotifications) =>
  n.data.__typename === 'MachineNotifications' && n.data.message.__typename === 'MachineNotificationsStarted';

/**
 * @customElement machine-started-template-notifications
 */
@Component({
  selector: 'machine-started-template-notifications',
  template(this: MachineStartedTemplateComponent) {
    const data = this.notification.data as IMachineNotifications;
    const message = data.message as IMachineNotificationsStarted;
    return html`
      <style>
        .spacer {
          flex: 1 3 auto;
        }
      </style>
      <div part="width" style="font-size: 12px; display: flex">
        <div style="margin-right: 13px; font-size: 22px;width: 45px">
          <!-- &#128187 -->
          ${ComputerIcon}
        </div>
        <div style="width: 100%;">
          <div style="min-height: 20px;">
            <span style="color: green; font-weight: 500">Started</span> Linode
            <a style="color: blue">${message.ip}</a>
            type
            <a style="color: blue">${message.worker_type}</a>
          </div>
          <div style="display: flex; margin-top: 5px;">
            <div>${this.dateTimeProvider.getDate(this.notification.createdAt)}</div>
            <span class="spacer"></span>
            <div>${this.dateTimeProvider.getHours(this.notification.createdAt)}</div>
          </div>
        </div>
      </div>
    `;
  },
})
export class MachineStartedTemplateComponent extends LitElement {
  @Inject(DateTimeProvider) private dateTimeProvider: DateTimeProvider;

  @property({ type: Object }) notification: INotifications;
}
